import Modal from "@client/controls/Modal/container";
import * as React from "react";

export type MapProps = {
  isVisible: boolean;
  title: string;
  description: string;
};

export interface ActionProps {
  onClose: () => void;
}

export default (props: ActionProps & MapProps) => (
  <Modal
    className="cartly_content_leaderboard_reward"
    hasBackdrop
    isAdminColor={false}
    isDraggable={false}
    isCentered
    isLoading={false}
    isVisible={props.isVisible}
    onClose={props.onClose}
  >
    <Modal.Header title={props.title} />
    <Modal.Body>
      <div dangerouslySetInnerHTML={{ __html: props.description }} />
    </Modal.Body>
  </Modal>
);
